import React from "react";
import { Translation } from "react-i18next";
import { Input } from '@abb/abb-common-ux-react';
import IThresholdSettings from '../../models/settings/ThresholdSettings';

interface IProps {
  settings: IThresholdSettings[];
  setColor: (id: string, v: string) => void
}

export default class ThresholdSettingLanding extends React.Component<IProps, {}> {
  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="page-layout h-100">
              <div className="summary-layout mt-4">
                <div className="col-12">
                  {this.props.settings.filter(i => i.name !== "Within Limit").map((data: IThresholdSettings, index: number) => {
                    return <div className="row mt-3" key={index}>
                      <label className="col-3">{t(data.name)}</label>
                      <Input
                        dataType="color"
                        className="col-2"
                        value={data.colorCode}
                        onValueChange={(v) => this.props.setColor(data.id, v)}
                        suffix={data.colorCode}
                      />
                    </div>
                  })}
                </div>
              </div>
            </div>
        }
      </Translation>
    );
  }
}
